/**
 * Directive: history
 */
angular.module('acme.common.directive.history', [
  'acme.common.directive.history.modal',
  'acme.common.service.helpers',
  'acme.common.service.api',
  'acme.common.service.userPreferences',
  'ui.bootstrap',
  'agGrid'
])
.directive('history', ['$uibModal', '$timeout', '$filter', 'ApiService', 'HelpersService', 'AuditTrailService', 'GridStateFactory', 'UserPreferencesService', function($uibModal, $timeout, $filter, ApiService, HelpersService, AuditTrailService, GridStateFactory, UserPreferencesService) {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/history/history.tpl.html',
      scope: {
        label: '@',
        component: '@',
        key: '@'
      },

      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', function($scope) {

        $scope.history = {

          query: '',
          dateFormat: HelpersService.dateFormats.shortDateTime,
          isVisible: true,
          pageSize: 7,
          pagination: {},
          model: [],
          gridState: new GridStateFactory(),
          paginationText: '',
          gridOptions: {},
          dataSource: false,
          columns: [
            {
              field: 'version',
              headerName: 'Version',
              cellRenderer: function (params) {
                return 'Version ' + params.value;
              }
            },
            {
              field: 'updatedBy',
              headerName: 'Updated By'
            },
            {
              field: 'updatedAt',
              headerName: 'Date',
              cellRenderer: function (params) {
                return $filter('date')(params.value, UserPreferencesService.getDateTimeFormat('shortDateTime'));
              }
            }
          ],
          
          init: function() {
            $scope.$on('auditTrail::backToHistory', $scope.history.showModalView);            
          },
          
          showModalView: function(e, data) {
            $scope.history.isVisible = data;
          },
          
          show: function() {
            $scope.history.gridState.resetGridState();
            var props = $scope.history.gridState.getGridState();

            if($scope.component){
              ApiService.history.list($scope.key, $scope.component, props).then(this.success.show, this.error.show);
            }
          },
          
          onGridDblClick: function(params) {
            var self = $scope.history;
            ApiService.history.auditTrail.list(params.data.version, $scope.key, $scope.component).then(self.success.auditTrail, self.error.auditTrail);
          },
          
          showModal: function(response) {
            var historyModal = $uibModal.open({
              templateUrl: 'common/directives/history/modal/historyModal.tpl.html',
              size: 'lg',
              scope: $scope,
              controller: 'historyModalCtrl',
              resolve: {
                items: function () {
                  return response;
                }
              }
            });
          },
          
          setDataForGrid: function(gridOptions, items) {
            var self = $scope.history;
              self.gridOptions = gridOptions;
            
            self.dataSource = {
              rowCount: -1,
              pageSize: self.pageSize,
              getRows: function (params) {
                self.getDataForGrid(params, gridOptions, items);
              }
            };
            
            $timeout(self.gridOptionsTimeOut, 10);
            
          },
          
          getDataGridProps: function(params, options) {
            var self = $scope.history, 
              props, success,
              currentPage = options.api.paginationController.currentPage + 1,
              currentSortModel = params.sortModel && params.sortModel.length > 0 ? params.sortModel[0] : false;
              
            self.gridState.updateGridState(currentPage, self.pageSize, currentSortModel.colId, currentSortModel.sort);
            props = self.gridState.getGridState();
            props.search = self.query;        
            return props;
          },
          
          
          getDataForGrid: function(params, options, items) {
            var self = $scope.history,
                props  = self.getDataGridProps(params, options);
            
            ApiService.history.list($scope.key, $scope.component, props).then(success, self.error.init);          
            
            function success(response) {
              var partners = response.data.payload.list || response.data.payload.entries,
                  lastRow = 0;

              try {
                lastRow = parseInt(self.pagination.count, 10);
              } catch (e) {
                lastRow = 0;
              }

              self.model = response.data.payload.list || response.data.payload.entries;

              if (self.model.length) {
                options.api.setHeaderHeight(30);
              } else {
                options.api.setHeaderHeight(0);
              }
              params.successCallback(self.model, lastRow);
              $timeout(self.paginationTimeout, 0);
            }
            
          },
          
          setPaginationText: function() {
            var current = parseInt($('#current').text(), 10),
              last = parseInt($('#total').text(), 10);

            if (!isNaN(current) && !isNaN(last)) {
              this.paginationText = current + ' of ' + last;
            }
          },
          
          success: {
            show: function(response) {
              var self = $scope.history;            
              self.pagination = response.data.payload.pagination;
              self.showModal(response);
            },
            
            auditTrail: function (res) {
              $scope.history.isVisible = false;
              AuditTrailService.init($scope.key, res.data.payload, $scope.component);
              $scope.$broadcast('history::auditTrail', { isVisible: true, path: $scope.component });
            },
            
            handleEmptyQuery: function(response) {
              var self = $scope.history;
              self.setDataForGrid(self.gridOptions, response);
            }
          },

          error: {
            show: function(response) {
              $scope.model = [];
              $scope.history.showModal();
            },
            
            auditTrail: function() {},
            handleEmptyQuery: function() {}
          },
          
          handleEmptyQuery: function() {
            var self = $scope.history, 
                props = self.gridState.getGridState();
            
            props.search = '';
            ApiService.history.list($scope.key, $scope.component, props).then(self.success.handleEmptyQuery, self.error.handleEmptyQuery);
            
          },
          
          gridOptionsTimeOut: function() {
            var self = $scope.history;
            if(self.gridOptions.api) {
              self.gridOptions.api.setDatasource(self.dataSource);
            }
          },
          
          gridResizeTimeout: function() {
            $scope.history.gridOptions.api.sizeColumnsToFit();
          },
          
          paginationTimeout: function() {
            $scope.history.setPaginationText();
          }

        };
        
        $scope.$on('$destroy', $scope.$watch('history.query', function(n, o) {
          var self = $scope.history, props;
          if (n !== o) {
            if(!!n) {
              self.setDataForGrid(self.gridOptions, false);
            } else {
              self.handleEmptyQuery();
            }
          }
        }));
        
        $scope.history.init();

      }]

    };

}]);